export default __webpack_public_path__ + "static/media/protect-your-assets.acf294bb.svg";